module.exports = __webpack_public_path__ + "static/media/2k3kplaceholder.6849ac0e.jpg";